import React, { useState } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import AppBar from "@mui/material/AppBar";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DashboardIcon from "@mui/icons-material/Dashboard";
import GroupIcon from "@mui/icons-material/Group";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import NotificationsIcon from "@mui/icons-material/Notifications";

import Header from "./Header";
import Referralpage from "./Referralpage";
import Dashboard from "./Dashboard";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";
import ProfilepageMain from "./ProfilepageMain";

const drawerWidth = 220;
const icons = [
  DashboardIcon,
  GroupIcon,
  NotificationsIcon,
  AccountCircleOutlinedIcon,
  LogoutOutlinedIcon,
];

const Sidebar = () => {
  const navigate = useNavigate();
  const [source, setSource] = useState(null);

  const Content = ({ selectedIcon }) => {
    switch (selectedIcon) {
      case "Dashboard":
        return (
          <Dashboard SelectedIcon={setSelectedIcon} setSource={setSource} />
        );
      case "Referrals":
        return (
          <div>
            <Referralpage source={source} />
          </div>
        );
      case "Referral Points":
        return <Typography variant="h4">Referral Points Content</Typography>;
      case "Notifications":
        return <Typography variant="h4">Coming Soon...</Typography>;
      case "My Profile":
        return <ProfilepageMain />;
      case "Logout":
        navigate("/signin");
        return null;
      default:
        return null;
    }
  };
  const [selectedIcon, setSelectedIcon] = useState("Dashboard");
  const [selectedItem, setSelectedItem] = useState(null);

  console.log("statusswas", selectedItem);
  const handleListItemClick = (text) => {
    setSelectedIcon(text);

    if (text === "Loyalties") {
      setSource("all");
    }
  };

  const handleListItem = (index) => {
    setSelectedItem(index);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 3 }}
      >
        <Header />
      </AppBar>
      <Drawer
        variant="permanent"
        sx={{
          border: "3px solid green",
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }}
      >
        <Toolbar />
        <Box sx={{ marginTop: "-12px" }}>
          <List>
            {[
              "Dashboard",
              "Referrals",
              "Notifications",
              "My Profile",
              "Logout",
            ].map((text, index) => (
              <ListItem
                key={text}
                disablePadding
                onClick={() => handleListItem(index)}
                style={{
                  backgroundColor:
                    selectedItem === index ? "#223D6C" : "inherit",
                  color: selectedItem === index ? "white" : "inherit",
                  marginBottom: text === "Notifications" ? "250px" : "0",
                }}
              >
                <ListItemButton onClick={() => handleListItemClick(text)}>
                  <ListItemIcon
                    style={{
                      color: selectedItem === index ? "white" : "inherit",
                    }}
                  >
                    {React.createElement(icons[index])}
                  </ListItemIcon>
                  <ListItemText primary={text} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>

          <Box
            sx={{ height: "20%", textAlign: "center", marginBottom: "-20%" }}
          >
            <Footer />
          </Box>
        </Box>
      </Drawer>
      <Box sx={{ marginTop: "90px", width: "100%" }}>
        <Content selectedIcon={selectedIcon} />
      </Box>
    </Box>
  );
};

export default Sidebar;
